/* eslint-disable import/no-extraneous-dependencies */
import React, {useRef, useEffect, useState} from 'react';
import {useSize} from 'ahooks';
import localeText from '@locale';

const Content = ({configData}) => {
  const listRef = useRef(null);
  const containerSize = useSize(listRef);
  const [cardNum, setCardNum] = useState(4);
  const [productNum, setProductNum] = useState(4);
  useEffect(() => {
    if (containerSize && containerSize.width) {
      if (containerSize.width >= 1000) {
        setCardNum(3);
      }
      if (containerSize.width < 1000) {
        setCardNum(2);
      }

      if (containerSize.width >= 1570 && containerSize.width < 1880) {
        setProductNum(5);
      }
      if (containerSize.width >= 1260 && containerSize.width < 1570) {
        setProductNum(4);
      }
      if (containerSize.width >= 950 && containerSize.width < 1260) {
        setProductNum(3);
      }
      if (containerSize.width >= 640 && containerSize.width < 950) {
        setProductNum(2);
      }
    }
  }, [containerSize]);

  return (
    <div className='content'>
      <div className='container' ref={listRef}>
        <div
          className='card'
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${cardNum}, minmax(320px, ${100 / cardNum}%))`,
            gridTemplateRows: `repeat(${Math.ceil(configData.Cards?.length / cardNum)}, ${100 / (Math.ceil(configData.Cards?.length / cardNum))}%)`,
            gridGap: '20px'
          }}
        >
          {
            configData.Cards.map((card) => (
              <div
                className='card-item'
                onClick={() => window.open(card.url)}
              >
                <div className='card-item-header'>
                  <img src={require(`~/${card.image}`)} alt={card.name} className='card-item-header-image' />
                  <span className='card-item-header-name'>{card.name}</span>
                  <div className='card-item-link'><img src={require('~/assets/images/landing/details.svg')} alt={card.name} /></div>
                </div>
                <div className='card-item-description'>{card.description}</div>
              </div>
            ))
          }
        </div>
        <div className='product'>
          <div className='product-title'>{localeText('COMMON.TXT_ALL_PRODUCTS')}</div>
          <div className='product-lists'>
            {
              configData.Products.map((product) => (
                <div className='product-list-item'>
                  <div className='product-list-item-category'>{product.category}</div>
                  <div
                    className='product-list-item-elements'
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${productNum}, minmax(270px, ${100 / cardNum}%))`,
                      gridGap: '8px'
                    }}
                  >
                    {product.item.map((element) => (
                      <div className='product-list-item-elements-item' onClick={() => window.open(element.url)}>
                        <div className='product-list-item-elements-item-image'>
                          <img src={require(`~/${element.image}`)} alt={element.name} />
                        </div>
                        <div className='product-list-item-elements-item-name'>{element.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
